import { createAsyncThunk } from '@reduxjs/toolkit';
import get from 'lodash/get';

import { getApiBaseUrl } from '../../utils/utilityFunctions';
import { getCookieData } from '../../utils/cookieHandler/handler';
import createRestApiClient from '../../utils/createRestApiClient';
import { getEnvVar } from '../../utils/env';

export const shareTest = createAsyncThunk(
  'shareTest/fetchShareTestLink',
  async (data, { rejectWithValue }) => {
    try {
      const HOST = getApiBaseUrl('https', undefined, true);

      const apiClient = createRestApiClient().withConfig({
        baseURL: HOST,
      }).client;

      let cookieName = getEnvVar('REACT_APP_COOKIE_NAME');
      let access_token = getCookieData(cookieName);
      if (!access_token) {
        window.location.href = getEnvVar('REACT_APP_LOGIN_URL') || window?._env_?.REACT_APP_LOGIN_URL;
      }

      const {
        addToast = () => {},
        extendDuration = false,
        toastVariants = {},
      } = window.toast || {};

      let endPoint = `${HOST}/lshs/api/v1.0/share-item/share`;
      if (!data.emailIds) {
        endPoint = `${HOST}/lshs/api/v1.0/share-item/generate-sharable-link`;
      }

      let headers = {
        Authorization: `Bearer ${access_token}`,
        Accept: 'application/json',
      };

      const response = await apiClient.post(`${endPoint}`, data, {
        headers: headers,
      });

      if (data.emailIds) {
        addToast({
          message: response?.data?.message,
          variant: toastVariants.SUCCESS,
          extendDuration,
        });
      }

      return response.data;
    } catch (error) {
      const {
        addToast = () => {},
        extendDuration = false,
        toastVariants = {},
      } = window.toast || {};

      if (data?.emailIds) {
        addToast({
          message:
            error?.response?.data?.message ||
            'Failed to share data, pls try again',
          variant: toastVariants.DANGER,
          extendDuration,
        });
      }

      const errorMessage = get(
        error,
        ['response', 'data', 'message'],
        error.message || 'Failed to share test'
      );
      return rejectWithValue(errorMessage);
    }
  }
);
